export const innerHTMLWithoutFont = (flagText = '') => {
  const div = document.createElement('div');
  div.innerHTML = flagText;

  if (div?.childNodes?.length === 1) {
    const element = div.childNodes[0];

    if (element?.nodeName === 'FONT' && element?.innerHTML?.length) {
      div.innerHTML = element.innerHTML;
    }
  }

  return div.innerHTML;
};
